(() => {
  'use strict';
  const reduce = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const seen = new WeakSet();
  const animations = new Set();
  const parallax = new Set();
  let queued = false;
  const permitted = () => !reduce.matches && !window.Shopify?.designMode;
  function play(el, frames, options) {
    if (!permitted() || !el.animate) return;
    const a = el.animate(frames, options);
    animations.add(a);
    a.finished.catch(() => {}).finally(() => animations.delete(a));
  }
  const reveal = 'main h2,main .oda-story-copy,main .oda-community-grid figure,main .ode-past-card,main .odd-past-grid article,main .ods-process li,main .odc-card,main .odp-slide,main .odp-card,main .odh-product,main .odh-customer,main .odh-selling-copy,main .product-card-wrapper,main .odd-product,main .odd-card,main .odi-topic,main .odi-contact>section,main .odi-photo-intro,main .oda-team-member,main .odh-founder-copy,main .odh-editorial-image,main .odh-confidence,main .odh-instagram-tile,main .ods-payout-card,main .ods-faq details,main .odfnd-faq details,main .ode-signup,main .odd-find,main .odi-hero,main .odi-photo-hero,main .oda-hero,main .ods-share-intro,main .ods-share-form';
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    let order = 0;
    entries.sort((a,b)=>a.boundingClientRect.top-b.boundingClientRect.top || a.boundingClientRect.left-b.boundingClientRect.left).forEach(({target, isIntersecting}) => {
      if (!isIntersecting) return;
      observer.unobserve(target);
      play(target,[{opacity:.75},{opacity:1}],{duration:300,easing:'ease-out'});
    });
  },{threshold:.12}) : null;
  function setup(root = document) {
    const nodes = [...(root.matches?.(reveal)?[root]:[]),...root.querySelectorAll(reveal)];
    nodes.forEach(el => {
      if (seen.has(el)) return;
      seen.add(el);
      if (el.closest('.scroll-trigger') || (el.getBoundingClientRect().top < innerHeight && el.getBoundingClientRect().bottom > 0)) return;
      observer?.observe(el);
    });
    root.querySelectorAll('main .odc-image,main .odd-product-photo img,main .ode-past-photo img,main .oda-community img,main .odp-photo img,main .odp-card-photo img,main .odh-product-photo img,main .odh-customer img').forEach(img => {
      if (img.complete || img.dataset.odLoadingBound) return;
      img.dataset.odLoadingBound = 'true';
      const placeholder = img.closest('.odc-image-wrap,.odc-media,.odd-product-photo,.ode-past-photo,.odp-photo,.odp-card-photo,.odh-product-photo') || img.parentElement;
      placeholder.classList.add('od-motion-loading');
      const done = () => placeholder.classList.remove('od-motion-loading');
      img.addEventListener('load',done,{once:true});
      img.addEventListener('error',done,{once:true});
      setTimeout(done,5000);
    });

    updateParallax();
  }
  function updateParallax() {
    queued = false;
    parallax.forEach(img => {
      if (!img.isConnected) {parallax.delete(img);return;}
      if (!permitted() || !desktop.matches) {img.style.removeProperty('translate');return;}
      const box = img.getBoundingClientRect();
      if (box.bottom < 0 || box.top > innerHeight) return;
      const amount = Math.max(-6,Math.min(6,((box.top+box.height/2)/innerHeight-.5)*12));
      img.style.translate = `0 ${amount.toFixed(2)}px`;
    });
  }
  addEventListener('scroll',() => {
    if (!queued && permitted() && desktop.matches && parallax.size) {queued=true;requestAnimationFrame(updateParallax);}
  },{passive:true});
  reduce.addEventListener('change',() => {animations.forEach(a=>a.cancel());updateParallax();});
  desktop.addEventListener('change',updateParallax);
  document.addEventListener('shopify:section:load',event=>setup(event.target));
  // Preserve native navigation, history and forms; animate only shopping routes.
  ['pageswap','pagereveal'].forEach(type=>addEventListener(type,event=>{
    const transition=event.viewTransition;
    if (!transition) return;
    const destination=type==='pageswap'?event.activation?.entry?.url:location.href;
    const path=destination?new URL(destination,location.href).pathname:'';
    if (!permitted() || !/^\/(?:$|collections(?:\/|$)|products\/|pages\/|policies\/)/.test(path)) {transition.skipTransition();return;}
    const cancel=()=>transition.skipTransition();
    document.addEventListener('pointerdown',cancel,{once:true});
    document.addEventListener('keydown',cancel,{once:true});
    transition.finished.finally(()=>{document.removeEventListener('pointerdown',cancel);document.removeEventListener('keydown',cancel);});
  }));
  const observeChanges = () => {
    const main = document.querySelector('main');
    if (!main || !('MutationObserver' in window)) return;
    const pending = new Set(); let scheduled = false;
    new MutationObserver(records => {
      records.forEach(r=>r.addedNodes.forEach(n=>{if(n.nodeType===1)pending.add(n);}));
      if (scheduled || !pending.size) return; scheduled = true;
      requestAnimationFrame(()=>{scheduled=false;pending.forEach(n=>{if(n.isConnected)setup(n);});pending.clear();});
    }).observe(main,{childList:true,subtree:true});
  };
  document.addEventListener('DOMContentLoaded',observeChanges,{once:true});
  if(document.readyState!=='loading')observeChanges();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>setup(),{once:true});else setup();
})();

